import Router from 'vue-router';
import Vue from 'vue';
import Home from './views/Home';
import CV from './views/CV';
import Projects from './views/Projects'
import Dissertation from './views/Dissertation'
import EntityAnalysisPage from './views/EntityAnalysisPage'
import Attributions from './views/Attributions'
import Contact from './views/Contact'
import DndPage from './views/Dnd'
import HouseWarming from './views/HouseWarming'
import Birthday23 from './views/Birthday-2k23'
import Birthday24 from './views/Birthday-2k24'
import Birthday25 from './views/Birthday-2k25'
import Birthday from './views/Birthday'
import QTSC from './views/QTSC'
// import DndMapPage from './views/DndMap'
import DndCampaignPage from './views/DndCampaign'

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/Projects',
      name: 'projects',
      component: Projects
    },
    {
      path: '/CV',
      name: 'cv',
      component: CV
    },
    {
      path: '/thesis',
      name: 'Dissertation',
      component: Dissertation
    },
    {
      path: '/entity-analysis',
      name: 'Entity Analysis',
      component: EntityAnalysisPage
    },
    {
      path: '/attributions',
      name: 'Attributions',
      component: Attributions
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact
    },
    {
      path: '/dnd',
      name: 'DND',
      component: DndPage,
      meta: { showGlasses: false }
    },
    {
      path: '/housewarming',
      name: 'Housewarming',
      component: HouseWarming,
      meta: { showGlasses: false, showHeader: false}
    },
    {
      path: '/birthday-23',
      name: 'Birthday23',
      component: Birthday23,
      meta: { showGlasses: false, showHeader: false}
    },
    {
      path: '/birthday-24',
      name: 'Birthday24',
      component: Birthday24,
      meta: { showGlasses: false, showHeader: false}
    },
    {
      path: '/birthday-25',
      name: 'Birthday25',
      component: Birthday25,
      meta: { showGlasses: false, showHeader: false}
    },
    {
      path: '/birthday',
      name: 'Birthday',
      component: Birthday,
      meta: { showGlasses: false, showHeader: false}
    },
    {
      path: '/qtsc',
      name: 'QTSC',
      component: QTSC,
      meta: { showGlasses: false, showHeader: false}
    },
    // // {
    // //   path: '/dnd-map',
    // //   name: 'DNDMap',
    // //   component: DndMapPage,
    // //   meta: { showGlasses: false }
    // // },
    {
      path: '/dnd-campaign',
      name: 'DNDCampaign',
      component: DndCampaignPage,
      meta: { showGlasses: false }
    },
  ]
});


